import { useState, useEffect } from "react";
import styled from '@emotion/styled'

import DatePicker from "react-datepicker";
import parseISO from 'date-fns/parseISO';

import { useTheme } from "@mui/material";

export const DateRangePickerWrapperStyled = styled.div`
  input {
    border-radius: 4px;
    border: 1px solid #ccc !important;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 16px;
    font-size: 1rem;
    font-weight: 300;
    font-weight: 400;
    height: 26px;
    letter-spacing: 0.00938em;
    line-height: 1.5;
    min-width: 200px;
    padding: 5px 10px; 
  }

  input.react-datepicker-ignore-onclickoutside {
    border: ${({ main }) => main} 1px solid !important;
    box-shadow: 0px 0px 0px 3px rgba(${({ mainRGB }) => mainRGB}, 0.25);
    outline: none;
  }

  input:focus{
    outline: none;
  }

  .react-datepicker__header {
    // background: red;
    font-size: 16px;
  }

  .react-datepicker__current-month {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__year-select {
    font-size: 16px;
  }

  .react-datepicker__close-icon {
    left: 232px;
    right: unset;
  }

  .react-datepicker__close-icon::after {
    background-color: ${({ main }) => main} !important;
  }
`;

const DateRangeInput = (props) => {
  const { id, type, typeName, order, input: { onChange, value }, dateFormat, locale, label, values } = props;
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [attribute, setAttribute] = useState({ MIN: null, MAX: null });

  const { palette } = useTheme();
  const { primary: { contrastText, main, mainRGB } } = palette;


  useEffect(() => {
    let defaultValue = [];
    const newAttribute = { ...attribute };

    if (values?.length > 0) {
      for (let i = 0; i < values.length; i++) {
        // if (!value && values[i].default) {
        if (values[i].value && values[i].default) {
          // defaultValue[values[i].typeName] = values[i]?.value ? JSON.stringify(values[i]?.value) : null;
          if (values[i].typeName === 'PERIOD-START') {
            defaultValue[0] = parseISO(values[i].value);
          }
          if (values[i].typeName === 'PERIOD-END') {
            defaultValue[1] = parseISO(values[i].value);
          }
        }
        if (values[i].typeName === 'MIN') {
          newAttribute.MIN = parseISO(values[i].value);
        }
        if (values[i].typeName === 'MAX') {
          newAttribute.MAX = parseISO(values[i].value);
        }
      }
      setAttribute(newAttribute);
    }

    // If no default value is set then assign min value
    // REMARK: Zero(0) value is NOT NULL VALUE, zero is the same as any other number value
    if (defaultValue == null) {
      // if (!required) {
      //   setValue(newAttribute['MIN']);
      //   onChange(newAttribute['MIN']);
      // }
      // if it has default value then set to store and input field value
    }
    if (defaultValue != null) {
      setDateRange(defaultValue);
      onChange({
        id,
        typeName,
        order,
        result: {
          start: defaultValue[0] ? defaultValue[0].toISOString() : null,
          end: defaultValue[1] ? defaultValue[1].toISOString() : null
        }
      });
    }
  }, []);

  return (
    <DateRangePickerWrapperStyled main={main} mainRGB={mainRGB}>
      <DatePicker
        locale={locale}
        isClearable="true"
        dateFormat={dateFormat}
        showYearDropdown="true"
        dropdownMode="select"
        selected={startDate}
        onChange={(update) => {
          setDateRange(update);
          // onChange({
          //   start: update[0] ? update[0].toISOString() : null,
          //   end: update[1] ? update[1].toISOString() : null
          // })

          if (!update[0] && !update[1]) {
            onChange(null);
          } else {
            onChange({
              id,
              typeName,
              order,
              result: {
                start: update[0] ? update[0].toISOString() : null,
                end: update[1] ? update[1].toISOString() : null
              }
            });
          }
        }}
        startDate={startDate}
        endDate={endDate}
        minDate={attribute.MIN ? new Date(attribute.MIN) : null}
        maxDate={attribute.MAX ? new Date(attribute.MAX) : null}
        selectsRange
      />
    </DateRangePickerWrapperStyled>
  );
}

export default DateRangeInput;